/**
 * Shifts the items of an array by a positive integer. The items are wrapped such that
 * items that "fall off" the end of the array end up at the beginning.
 */
export function arrayShift<T>(pl: T[], shift: number) {
  const t = pl.slice();

  for (let i = 0, l = t.length; i < l; i++) {
    pl[(shift + i) % l] = t[i];
  }

  return pl;
}
